export enum Channel {
  WHATSAPP = "WhatsApp",
  WHATSAPP360 = "WhatsApp360",
  WHATSAPP360CLOUD = "WhatsApp360Cloud",
  SMS = "SMS",
  INTERNAL = "Internal",
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
}
